/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CancellationRevokeRequest interface.
 */
export function instanceOfCancellationRevokeRequest(value) {
    if (!('token' in value) || value['token'] === undefined)
        return false;
    return true;
}
export function CancellationRevokeRequestFromJSON(json) {
    return CancellationRevokeRequestFromJSONTyped(json, false);
}
export function CancellationRevokeRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'token': json['token'],
    };
}
export function CancellationRevokeRequestToJSON(json) {
    return CancellationRevokeRequestToJSONTyped(json, false);
}
export function CancellationRevokeRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'token': value['token'],
    };
}
